'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.errorKey = undefined;
exports.noop = noop;
exports.ctrDot = ctrDot;
exports.clickDot = clickDot;
exports.getLocale = getLocale;
exports.getSnsList = getSnsList;
exports.getSnsListLogin = getSnsListLogin;
exports.getEDMRequest = getEDMRequest;
exports.isMobile = isMobile;
exports.trigger = trigger;

var _zoroClickstat = require('@alife/zoro-clickstat');

var _zoroClickstat2 = _interopRequireDefault(_zoroClickstat);

var _zoroCookie = require('@alife/zoro-cookie');

var _zoroCookie2 = _interopRequireDefault(_zoroCookie);

var _zoroRequest = require('@alife/zoro-request');

var _zoroRequest2 = _interopRequireDefault(_zoroRequest);

var _zoroMtop = require('@alife/zoro-mtop');

var _zoroMtop2 = _interopRequireDefault(_zoroMtop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function noop() {}

// 曝光打点
function ctrDot(arg) {
    _zoroClickstat2.default.ctr({
        projectId: 180119,
        expPageArea: arg.expPageArea,
        expType: arg.expType,
        expAttribute: arg.expAttribute
    });
}

// 点击打点
function clickDot(arg) {
    _zoroClickstat2.default.buttonClick({
        projectId: 180119,
        pageType: arg.pageType,
        buttonType: arg.buttonType,
        objectType: arg.objectType,
        objectValue: arg.objectValue
    });
}

// 从cookie中获取locale
function getLocale() {
    var locale = _zoroCookie2.default.getLocale();
    if (locale) {
        return locale.toLocaleLowerCase().replace('_', '-');
    } else {
        return 'en-us';
    }
}

// 注册配置接口
function getSnsList(registerFrom) {
    return (0, _zoroRequest2.default)({
        url: 'https://login.aliexpress.com/join/uiConfig.htm',
        data: {
            registerFrom: registerFrom
        },
        withCredentials: true // 支持附带详细信息
    });
}

// 登录配置接口
function getSnsListLogin(loginFrom) {
    return (0, _zoroRequest2.default)({
        url: 'https://login.aliexpress.com/join/loginUiConfig.htm',
        data: {
            loginFrom: loginFrom
        },
        withCredentials: true // 支持附带详细信息
    });
}

// 是否订阅邮件通知
function getEDMRequest(type) {
    // window.lib.mtop.config.prefix = 'ru-pre-acs';
    return _zoroMtop2.default.request({
        api: 'mtop.aliexpress.buyer.subscribe.config.4reg.get',
        v: '1.0',
        data: {
            clientType: type,
            memberSeq: 1006680305, // 后端传送
            appName: 'AliExpress',
            // lang: "en_US" //
            _lang: _zoroCookie2.default.getBuyerLocale() || 'en_US'
        }
    });
}

function isMobile() {
    return (/(iPhone|Android)/i.test(navigator.userAgent)
    );
}

var errorKey = exports.errorKey = {
    timeout: 'timeout',
    loadScriptError: 'loadScriptError',
    noEmailData: 'noEmailData',
    nologinList: 'nologinList',
    joinSuccess: 'joinSuccess',
    parseDa: 'parseDa',
    checkEmailSuccess: 'checkEmailSuccess',
    initNoCaptchaError: 'initNoCaptchaError',
    sendPostReturnUndefined: 'sendPostReturnUndefined',
    noUmidToken: 'noUmidToken',
    noCsessionidSig: 'noCsessionidSig'
};
/**
 *  触发事件
 * @param {string} eventname
 */
function trigger(eventname) {
    if (document.createEvent) {
        // DOM Level 2 standard
        // Events，HTMLEvents，UIEevents，MouseEvents，MutationEvents
        var evt = document.createEvent('Events');
        // initEvent，initUIEvent，initMouseEvent，initMutationEvent
        evt.initEvent(eventname, true, true);
        document.body.dispatchEvent(evt);
    } else if (document.fireEvent) {
        // IE
        document.body && document.body.fireEvent('on' + eventname);
    }
}